export default __webpack_public_path__ + "media/images/icons_fc/present-fbe4cb3b82dd020cd70597db9e51d7d9.png";